export default __webpack_public_path__ + "static/media/ef5216442e048ef482c5be64911f45801599781810540.1fbefda2.webp";